import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

import { Header as BaseHeader } from '@common/components/Header';
import { Search } from "@common/components/Search";
import Dropdown from "@common/containers/fields/Dropdown";
import { Flex } from '@common/components/Flex';
import { Button } from "@common/components/Button";
import { getAppConfig } from "@common/utils/config";
import {getTestAttributes} from "@common/utils/tests";
import { MODULE_NAME } from '@modules/individuals';

import './header.styles.scss';

const filterCategoryStyles = {
  control: (styles) => ({
    ...styles,
    minWidth: '170px',
    width: 'max-content',
  }),
  singleValue: (styles) => ({
    ...styles,
    maxWidth: 'none',
  }),
  menu: (styles) => ({
    ...styles,
    width: 'max-content',
    minWidth: '100%',
  }),
  option: (styles, {isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? 'transparent' : undefined,
      overflow: 'visible',
      textOverflow: 'clip',
    };
  },
};

export const Header = (props) => {
  const { className, onFilterChange, onNewIndividualOpen, probandCategory } = props;
  const categories = [{value: true, label: I18n.t('Only Probands')}, {value: false, label: I18n.t('All Individuals')}];

  const individualsConfig = getAppConfig().individuals || {};

  const handleCategoryChange = React.useCallback((selectedValue) => {
    const selectedCategory = categories.find(option => option.value === selectedValue);
    onFilterChange({ probandsOnly: selectedCategory.value });

  }, [onFilterChange]);

  const handleFilterChange = React.useCallback((value) => {
    onFilterChange({ search: value.searchKeyword });
  }, [onFilterChange]);

  return (
    <BaseHeader 
      moduleName={I18n.t('Individuals')}
      className={cx('IndividualsHeader', className)}
    >
      <Search
        {...getTestAttributes({ id: "ind-home-tab-act-search-panel-tx-search" })}
        withLiveSearch={individualsConfig.liveSearchEnabled}
        liveSearchDelay={individualsConfig.liveSearchDelay}
        className="Individuals__header__search"
        onSearch={handleFilterChange}
      />
        <Flex className="Individuals__header__toolbar-right">
          <Dropdown
            {...getTestAttributes(MODULE_NAME, 'filter-category', 'category-dropdown')}
            className="Individuals__header__category"
            selectedValue={probandCategory}
            searchable={false}
            options={categories}
            onValueChanged={handleCategoryChange}
            styles={filterCategoryStyles}
          />
          <Button
            {...getTestAttributes({ id: "ind-home-tab-new-individual" })}
            bsStyle="primary"
            onClick={onNewIndividualOpen}
          >
            <i className="fa fa-plus"></i>
            {I18n.t('New Individual')}
          </Button>
        </Flex>
    </BaseHeader>
  );
};